import React, { useState } from "react";
import Auth from "../../components/Auth/Auth";
import lock from "../../assets/images/lock.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../features/slices/authReducer";
import { useDispatch } from "react-redux";
const initialState = {
  newPassword: "",
  confirmPassword: "",
  errors: {},
  loading: false,
  eye: {
    newPasswordEye: false,
    confirmPasswordEye: false,
  },
};
const ResetPassword = () => {
  const { search } = useLocation();
  const token = search.split("?")[2];
  const [iState, updateState] = useState(initialState);
  const { newPassword, confirmPassword, errors, eye, loading } = iState;
  const { newPasswordEye, confirmPasswordEye } = eye;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const toggleEye = (field) => {
    updateState({
      ...iState,
      eye: {
        ...eye,
        [field]: !eye[field],
      },
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateState({
      ...iState,
      [name]: value,
      errors: "",
    });
  };
  const handleValidation = () => {
    let error = {};
    let formIsValid = true;

    if (!newPassword || newPassword.length < 6) {
      error.newPasswordError = "New password must be at least 6 characters";
      formIsValid = false;
    }

    if (!confirmPassword || confirmPassword.length < 6) {
      error.confirmPasswordError =
        "Confirm password must be at least 6 characters";
      formIsValid = false;
    } else if (newPassword !== confirmPassword) {
      error.confirmPasswordError = "Passwords do not match";
      formIsValid = false;
    }
    updateState({
      ...iState,
      errors: error,
    });

    return formIsValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ token, search });

    const data = { password: newPassword, token };
    if (handleValidation()) {
      updateState({ ...iState, loading: true });
      dispatch(resetPassword(data)).then((data) => {
        if (data?.payload?.code === 200) {
          updateState({ ...iState, loading: false });
          navigate("/loginSuccess");
        } else {
          updateState({ ...iState, loading: false });
        }
      });
    }
  };
  return (
    <Auth>
      <h2>Create a new Password</h2>
      <h6>Welcome back, you’ve been missed!</h6>
      <form>
        <div className="form-group">
          <label>Password</label>
          <input
            type={newPasswordEye ? "text" : "password"}
            className="form-control"
            placeholder="Enter your new password"
            name="newPassword"
            value={newPassword}
            onChange={handleChange}
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
          />{" "}
          <span className="Icon">
            <img src={lock} />
          </span>
          <span className="icon" onClick={() => toggleEye("newPasswordEye")}>
            {!newPasswordEye ? (
              <i className="fa fa-eye-slash" aria-hidden="true" />
            ) : (
              <i className="fa fa-eye" aria-hidden="true" />
            )}
          </span>
          {errors.newPasswordError && (
            <p className="d-flex justify-content-start text-danger mt-2 ">
              {errors.newPasswordError}
            </p>
          )}
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <input
            type={confirmPasswordEye ? "text" : "password"}
            className="form-control"
            placeholder="Enter confirmed password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleChange}
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
          />
          <span className="Icon">
            <img src={lock} />
          </span>
          <span
            className="icon"
            onClick={() => toggleEye("confirmPasswordEye")}
          >
            {!confirmPasswordEye ? (
              <i className="fa fa-eye-slash" aria-hidden="true" />
            ) : (
              <i className="fa fa-eye" aria-hidden="true" />
            )}
          </span>
          {errors.confirmPasswordError && (
            <p className="d-flex justify-content-start text-danger mt-2 ">
              {errors.confirmPasswordError}
            </p>
          )}
        </div>
        <button
          type="submit"
          className={`Button`}
          style={{
            width: "100%",
          }}
          disabled={loading}
          onClick={handleSubmit}
        >
          Submit
        </button>
        <div className="Checkboxs">
          <p className="BackToLogin">
            Back to <Link to={"/login"}>Sign In</Link>
          </p>
        </div>
      </form>
    </Auth>
  );
};

export default ResetPassword;
